import { getCurrentInstance } from "vue"

export function useZoox() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error(`useZoox deve ser instanciada dentro da função setup().`)
  }
  return instance.proxy.$zoox
}
